export enum BalanceType {
  YuE = 1,
  QuanYiJin,
}

// 余额管控弹窗用
export enum DisplayType {
  Modal = 1, // 弹窗
  HalfSheet = 2, // 半浮层
}

export enum ExceptionCategory {
  Entry = '【入口】',
  Log = '【日志】',
  Expect = '【预期流程埋点】',
  Exception = '【异常流程埋点】',
  PageException = '【页面流程】',
  CustomBridge = '【自定义桥】',
  KNBBridge = '【KNB 桥】',
  VueErrorHandler = '【vueErrorHandler】',
}
